import { render } from "./CreateTypeService.vue?vue&type=template&id=23aad0c8&scoped=true"
import script from "./CreateTypeService.vue?vue&type=script&lang=js"
export * from "./CreateTypeService.vue?vue&type=script&lang=js"

import "./CreateTypeService.vue?vue&type=style&index=0&id=23aad0c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23aad0c8"]])

export default __exports__